﻿export const AppContainerId = 'veilederBarnestipend';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksC1 = 'boks-c1';
export const BoksC2 = 'boks-c2';
